import { formatEther } from 'ethers'
import { useEffect } from 'react'

import { useToast } from '@chakra-ui/react'
import { useAddRecentTransaction } from '@rainbow-me/rainbowkit'
import { useAccount, useSimulateContract, useWriteContract } from 'wagmi'

import { useTokenxGGPContract } from './contracts/tokenggAVAX'

import { DECODED_ERRORS } from '@/utils/consts'

const useDeposit = (amount: bigint) => {
  const { abi, address } = useTokenxGGPContract()
  const addRecentTransaction = useAddRecentTransaction()
  const toast = useToast()
  const { address: userAddress } = useAccount()

  const simulation = useSimulateContract({
    address,
    abi,
    functionName: 'deposit',
    enabled: amount !== 0n,
    args: [amount, userAddress],
    onError(error) {
      Object.keys(DECODED_ERRORS).forEach((key) => {
        if (error?.message.includes(key)) {
          toast({
            position: 'top',
            title: 'Error during deposit of GGP',
            description: DECODED_ERRORS[key],
            status: 'error',
            duration: 20000,
            isClosable: true,
          })
        }
      })
    },
  })

  const { data: hash, error: writeError, isPending, reset, writeContract } = useWriteContract()

  // Periodic refetch of simulation data
  useEffect(() => {
    const intervalId = setInterval(() => {
      simulation.refetch()
    }, 3000)

    return () => clearInterval(intervalId) // Clean up interval on unmount
  }, [simulation])

  useEffect(() => {
    if (hash) {
      addRecentTransaction({
        hash,
        description: `Deposit ${formatEther(amount)} AVAX`,
      })
    }
  }, [hash, addRecentTransaction, amount])

  return {
    hash,
    data: simulation.data,
    isError: simulation.error,
    isLoading: simulation.isLoading,
    refetch: simulation.refetch,
    write: writeContract,
    reset,
    isPending,
    writeError,
    ready: writeContract !== undefined,
  }
}

export default useDeposit
